import React from 'react';
import { globalMenuItems } from '../../App';
import { useExposure } from '../../hooks/useExposure';
import { useMaterials } from '../../hooks/useMaterials';
import { useUser } from '../../hooks/useUser';
import Sidebar from './Sidebar/sidebar';
import TopBar from './TopBar/TopBar';
import { useAccountStore } from '../Stores/accountStore';
import { Account } from '../../sp-types/accountTypes';

type TopSideBarProps = {
  children?: React.ReactNode;
  currentItem: string;
};

const TopSideBars: React.FC<TopSideBarProps> = ({ children, currentItem }) => {
  const { data: userData } = useUser();
  const { account } = useAccountStore();

  // The hooks are here to initialize the data
  // eslint-disable-next-line no-empty-pattern
  const {} = useExposure();
  // eslint-disable-next-line no-empty-pattern
  const {} = useMaterials();

  const additional = userData?.menuItem || [];
  const isAdmin = !!userData?.isAdmin;
  const filterMenu = (items: any[], account: Account) => {
    return account.isSalesCommitment
      ? items.filter((m) => !m.isSalesCommitment || m.isSalesCommitment === 1)
      : items.filter((m) => !m.isSalesCommitment || m.isSalesCommitment === 2);
  };
  return (
    <div className="flex h-screen overflow-hidden ">
      <div className="2xl:w-56 flex-shrink-0 bg-primary_text overflow-y-scroll ">
        <Sidebar
          items={[...filterMenu(globalMenuItems, account), ...additional]}
          currentItem={currentItem}
          isAdmin={isAdmin}
        />
      </div>
      <div className="flex flex-col flex-1 min-w-0 max-h-screen">
        <TopBar currentPage={currentItem} />
        <div className="flex-1 overflow-auto p-3">{children}</div>
      </div>
    </div>
  );
};

export default TopSideBars;
